import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  currentDisplayCurrency,
  setDisplayCurrency,
  supportedDisplayCurrencies,
} from '@/lib/displayCurrency';
import { markManualCurrency } from '@/lib/manualCurrency';

export function CurrencySwitcher({ onChange }: { onChange?: (code: string) => void }) {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(currentDisplayCurrency());

  return (
    <label className="relative inline-flex items-center text-sm">
      <span className="sr-only">{t('common.currency')}</span>
      <select
        value={current}
        onChange={(e) => {
          const v = e.target.value;
          setDisplayCurrency(v);
          markManualCurrency();
          setCurrent(v);
          onChange?.(v);
        }}
        className="appearance-none rounded-md border border-ink-200 bg-white px-2.5 py-1.5 pr-7 text-sm text-ink-700 hover:border-ink-300 focus:outline-none focus:ring-2 focus:ring-accent-500"
      >
        {supportedDisplayCurrencies().map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
      <svg className="pointer-events-none absolute right-2 h-4 w-4 text-ink-400" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.06l3.71-3.83a.75.75 0 111.08 1.04l-4.25 4.4a.75.75 0 01-1.08 0L5.21 8.27a.75.75 0 01.02-1.06z" clipRule="evenodd" />
      </svg>
    </label>
  );
}
